import React from 'react';
import RadioButton from '../RadioButton/RadioButton';
import styles from './RadioButtonGroup.module.css';

interface RadioButtonGroupProps {
  label: string;
  name: string;
  value: string;
  setValue: (v: string) => any;
  required?: boolean;
}

function RadioButtonGroup({ label, name, value, setValue, required = false }: RadioButtonGroupProps) {
  return (
    <div className={styles.radioButtonGroup}>
      <div className={styles.radioButtonGroupLabel}>
        {label}
        {required && ' *'}
      </div>
      <div className={styles.radioButtonContainer}>
        <RadioButton
          required={required}
          checked={value === 'Yes'}
          onChange={() => setValue('Yes')}
          text="Yes"
          name={name}
        />
        <RadioButton
          required={required}
          checked={value === 'No'}
          onChange={() => setValue('No')}
          text="No"
          name={name}
        />
      </div>
    </div>
  );
}

export default RadioButtonGroup;
